import { Mesh, MeshLambertMaterial, RepeatWrapping } from 'three'
import type { Engine } from '../../../core/engine/Engine.type'
import type { RiverEntity } from '../../../core/entity/EntityType/River'
import tmpRng from '../../../core/rng/tmpRng'
import { HALF_PI } from '../../../core/util/math/Math'
import applyVertexFunctionStandardMaterialV2 from '../../fn/applyVertexFunctionStandardMaterialV2'
import generateNoiseTexture from '../../fn/generateNoiseTexture'
import { useRiverBasinColors } from './colors'
import createRiverTerrainGeometry from './createRiverTerrainGeometry'

const debugWireFrame = !true

// a regular plane will have all it's triangles
// pointing diagonally in the same direction
export default function createRiverTerrainMesh(
  engine: Engine,
  riverEnts: Array<RiverEntity>,
) {
  const geometry = createRiverTerrainGeometry(engine, riverEnts)
  geometry.rotateX(-HALF_PI)
  // console.log('geometry', geometry)

  // const geometry = new PlaneGeometry(10, 10, 10, 10)

  const material = new MeshLambertMaterial({
    //
  })
  if (debugWireFrame) {
    material.wireframe = true
  }

  const noiseTexture1 = generateNoiseTexture(64, tmpRng, 127, 255)
  noiseTexture1.wrapS = noiseTexture1.wrapT = RepeatWrapping
  noiseTexture1.repeat.set(64, 64)
  material.bumpMap = noiseTexture1

  const noiseTexture2 = generateNoiseTexture(64, tmpRng, 127, 255)
  noiseTexture2.wrapS = noiseTexture2.wrapT = RepeatWrapping
  noiseTexture2.repeat.set(64, 64)
  material.lightMap = noiseTexture2
  material.lightMapIntensity = 1

  // material.needsUpdate = true

  const mesh = new Mesh(geometry, material)
  mesh.name = 'RiverTerrain'
  applyVertexFunctionStandardMaterialV2(mesh, useRiverBasinColors)
  mesh.position.y += 1

  // mesh.visible = false

  return mesh
}
